import { useState } from "react";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";

interface FormDealerProps {
  blob: Blob;
}

const FormDealer: React.FC<FormDealerProps> = ({ blob }) => {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const bodyFormData = new FormData();
    bodyFormData.append("contact_fname", fname);
    bodyFormData.append("contact_lname", lname);
    bodyFormData.append("contact_email", email);
    bodyFormData.append("contact_phone", phone);
    bodyFormData.append("contact_address", address);
    bodyFormData.append("contact_city", city);
    bodyFormData.append("contact_state", state);
    bodyFormData.append("contact_zip", zip);
    bodyFormData.append("the_file", blob, "myboat.pdf");
    axios({
      method: "post",
      url: "http://localhost/wp-json/boat-builder/v1/dealer",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setLoading(false);
        const { data } = response;
        if (data.status !== 200) {
          setErrMessage(data.message);
        } else {
          setErrMessage("");
          setSuccess(true);
        }
      })
      .catch(function (response) {
        setLoading(false);
        setErrMessage("There was some unknown Error, Please try again.");
      });
  };
  return (
    <>
      <div className={success ? "form-success active" : "form-success"}>
        <div>
          <div className="icon-container">
            <FaCheckCircle />
          </div>
          <h2 className="message">Success! Email Sent.</h2>
        </div>
      </div>
      <div className={loading ? "loader active" : "loader"}></div>
      <form className="formDealer" onSubmit={submitForm}>
        {errMessage ? (
          <div className="form-error">{errMessage}</div>
        ) : (
          <div></div>
        )}
        <div className="form-container">
          <div className="form-input-container">
            <label htmlFor="fname">First Name:</label>
            <input
              name="fname"
              type="text"
              onChange={(e) => setFname(e.target.value)}
              value={fname}
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="lname">Last Name:</label>
            <input
              name="lname"
              type="text"
              onChange={(e) => setLname(e.target.value)}
              value={lname}
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="email">Email:</label>
            <input
              name="email"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="phone">Phone:</label>
            <input
              name="phone"
              type="tel"
              onChange={(e) => setPhone(e.target.value)}
              value={phone}
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="address">Address:</label>
            <input
              name="address"
              type="text"
              onChange={(e) => setAddress(e.target.value)}
              value={address}
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="city">City:</label>
            <input
              name="city"
              type="text"
              onChange={(e) => setCity(e.target.value)}
              value={city}
            />
          </div>
          <div className="form-input-container">
            <label htmlFor="state">State:</label>
            <select name="state" onChange={(e) => setState(e.target.value)}>
              <option value="" disabled selected>
                Select a State
              </option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
          </div>
          <div className="form-input-container">
            <label htmlFor="zip">Zip:</label>
            <input
              name="zip"
              type="text"
              onChange={(e) => setZip(e.target.value)}
              value={zip}
            />
          </div>
        </div>
        <input type="submit" value="Send" />
      </form>
    </>
  );
};

export default FormDealer;
